import { render, staticRenderFns } from "./ProposteSoggiornoList.vue?vue&type=template&id=539048ab&scoped=true"
import script from "./ProposteSoggiornoList.vue?vue&type=script&lang=js"
export * from "./ProposteSoggiornoList.vue?vue&type=script&lang=js"
import style0 from "./ProposteSoggiornoList.vue?vue&type=style&index=0&id=539048ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539048ab",
  null
  
)

export default component.exports